<div fxLayout="column" class="heading">
    <span class="width">Payment Receipt</span>
    <p class="width">
        Thank you very much for your interest in Creatics! We thank you for purchasing the {{names}} badge.
    </p>
    <div class="main-div width" fxLayout="row wrap">
        <div class="information">
            <p>
                Status : Successful<br><br>
                Date : {{currentDate | date:'MMMM d, y, h:mm:ss a'}} {{userTimezoneNameSP(currentDate)}}
            </p>
 
            <p *ngIf="paymentType === 'Creatics Currency'">Payment Type : {{paymentType}}</p>
            <p *ngIf="paymentType === 'Card Payment'">Payment Type : {{paymentType}}</p>
            <p *ngIf="paymentType === 'Card Payment'">Amount : ${{amount}}</p>
            <p *ngIf="paymentType === 'Creatics Currency'">Amount : {{currency}} Creatics Currency</p>
            <p *ngIf="paymentType === 'Card Payment'">Transaction ID : {{transId}}</p>
            <span (click)="goBack()">Return to Badges and Awards</span>
        </div>
    </div>
</div>